/* Dr.Primal — the kit offer selector (high-performance landing page).

   A sibling of dp-buy-box.js for the one-time kit bundles: no selling plans, no tier
   machinery, no reconciliation guard — a kit variant IS its own price, so there is no
   advertised-vs-charged gap to police. It selects a card, keeps the add button's price
   in step, and posts a single one-time line, then hands the cart drawer the same
   `dp:cart:updated` event the buy box uses so the drawer opens and refreshes. */
(function () {
  'use strict';

  if (window.dpKitOfferLoaded) return;
  window.dpKitOfferLoaded = true;

  var SECTIONS = 'dp-cart-drawer,dp-header';

  function root() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function sectionsUrl() {
    return window.location.pathname + window.location.search;
  }

  /* Move the picker into the slot the buy box marks with `hide_offers`, when there is
     one - the same relocation contract as dp-purchase-options.js: sections cannot nest,
     so on a PDP the kit picker renders after the hero and is lifted into the buy column
     where the offer ladder stood, shedding its band styling on arrival. Without the
     slot (the landing pages) nothing moves. */
  function relocate(offer) {
    var slot = document.querySelector('[data-dp-po-slot]');
    var band = offer.closest('.dp-kit-offer');
    if (!slot || !band || slot.contains(band)) return;
    band.classList.add('dp-kit-offer--inline');
    slot.appendChild(band);
  }

  function init() {
    var offer = document.querySelector('[data-dp-kit-offer]');
    if (!offer) return;

    relocate(offer);

    var addButton = offer.querySelector('[data-dp-kit-add]');
    var errorNode = offer.querySelector('[data-dp-kit-error]');
    if (!addButton) return;

    var busy = false;

    function selectedRadio() {
      return offer.querySelector('[data-dp-kit-radio]:checked');
    }

    function showError(message) {
      if (!errorNode) return;
      errorNode.textContent = message;
      errorNode.hidden = !message;
    }

    function setBusy(state) {
      busy = state;
      addButton.disabled = state;
    }

    /* The add button carries its label only — no price. The per-kit price is already on
       each card (and mirrored on the sticky bar's button), so repeating it here read as
       clutter (client, 2026-09-08). */
    offer.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[data-dp-kit-radio]')) {
        showError('');
      }
    });

    addButton.addEventListener('click', function () {
      if (busy) return;
      var radio = selectedRadio();
      if (!radio) {
        showError('Choose a kit first.');
        return;
      }
      var card = radio.closest('[data-dp-kit-card]');
      if (card && card.getAttribute('data-dp-kit-available') !== 'true') {
        showError('That kit is currently unavailable.');
        return;
      }

      showError('');
      setBusy(true);

      var posted = false;
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(radio.value, 10), quantity: 1 }],
          sections: SECTIONS,
          sections_url: sectionsUrl(),
        }),
      })
        .then(function (response) {
          if (response.ok) posted = true;
          return response.json().catch(function () { return {}; });
        })
        .then(function (result) {
          if (!posted) throw new Error('add-failed');
          document.dispatchEvent(
            new CustomEvent('dp:cart:updated', {
              detail: { sections: result.sections, open: true, trigger: addButton },
            })
          );
        })
        .catch(function () {
          showError('The kit could not be added. Nothing has been charged — please try again.');
        })
        .then(function () {
          setBusy(false);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
